import React from 'react';
import { Row, Col } from 'antd';
import Badge from '../Badge';
import Text from '../Text/Text';
import { StatusType } from '../../types';
import Avatar from '../Avatar/Avatar';
import IconLeftRightArrow from '../Icons/IconLeftRightArrow';
import TaskDefaultImage from '../../images/taskDefaultImage.png';
import './TasksListItem.less';
import isEmpty from 'lodash/isEmpty';

export type TasksListItemProps = {
  title?: string;
  author?: string;
  status?: StatusType;
  statusText?: string;
  image?: string;
  description?: string;
  assignedBy?: {
    id: string;
    image: string;
    fullName: string;
  };
  assignee?: {
    id: string;
    image: string;
    fullName: string;
  };
  section?: {
    title: string;
  };
  onItemClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
};

const TTasksListItem: React.FC<TasksListItemProps> = ({
  title,
  author,
  status = StatusType.SUCCESS,
  statusText = 'Success',
  image,
  description,
  section,
  assignedBy,
  assignee,
  onItemClick,
}) => {
  const classNames = ['t-tasksListItem', `t-tasksListItem-${status}`];

  return (
    <div className="t-tasksListItem" onClick={onItemClick}>
      <div className="t-avatar-wrapper">
        <Avatar src={image || TaskDefaultImage} size="md" />
      </div>
      <Row className="t-content-row">
        <Col span={18} className="t-content-info">
          <Text rows={2} level={2} bold paddingBottom={3}>
            {section.title}
          </Text>

          <div className="t-tasks-assigned-wrapper">
            {!isEmpty(assignedBy) && (
              <Avatar
                src={assignedBy.image}
                size="xs"
                name={assignedBy.fullName}
                text={assignedBy.fullName}
                textLevel={3}
                avatarColor="indicator-neutral"
              />
            )}
            {!isEmpty(assignee) && !isEmpty(assignedBy) && (
              <div className="t-icon-leftTight-wrapper">
                <IconLeftRightArrow size="sm" />
              </div>
            )}
            {!isEmpty(assignee) && (
              <Avatar
                src={assignee.image}
                size="xs"
                name={assignee.fullName}
                text={assignee.fullName}
                textLevel={3}
                avatarColor="indicator-neutral"
              />
            )}
          </div>
        </Col>
        <Col span={6} className="t-statusContainer">
          <Badge status={status} statusText={statusText} />
        </Col>
      </Row>
    </div>
  );
};

export default TTasksListItem;
